export default function messageOnListUsers(status) {
    let message

    switch (status) {
        case 503:
            message =
                'Ops! Ocorreu um problema com a internet e não conseguimos obter a lista de usuários. Por favor, verifique a sua internet.'
            break
        default:
            message =
                'Ops! Algo de estranho ocorreu e não conseguimos obter a lista de usuários. Por favor, tente novamente mais tarde.'
    }
    return message
}
